import Language, { LanguageBody } from "src/models/Language"
import { setLanguage, setLanguages, setOpenLanguages } from "src/redux/features/languages/languageSlice"

export const createLanguage = async (langugeInfos: LanguageBody, toast: any) => {
    const response: any = await Language.createLanguage(langugeInfos);

    if (response.status === 200) {
        toast({
            description: `La langue a été créé avec succès`,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: true }
    } else if (response.status !== 500) {
        toast({
            description: `${response?.message?.message}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    } else {
        toast({
            description: `quelque chose s'est mal passé !`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    }
}

export const updateLanguage = async (id: string, languagesInfos: LanguageBody, toast: any, dispatch: any) => {
    const response: any = await Language.updateLanguage(id, languagesInfos)
    if (response.status === 200) {

        const response2: any = await Language.getLanguage(id)
        dispatch(setLanguage(response2?.data.data))
        toast({
            description: `La langue a été mis à jour avec succès !`,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: true }
    } else if (response.status !== 500) {
        toast({
            description: `${response?.message?.message}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    } else {
        toast({
            description: `quelque chose s'est mal passé !`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    }
}

export const getLanguages = async (dispatch: any) => {
    const response: any = await Language.getLanguages()
    if (response.status === 200) {
        dispatch(setLanguages(response.data.data))
        return { status: true }
    } else {
        return { status: false }
    }
}

export const getOpenLanguages = async (dispatch: any) => {
    const response: any = await Language.getOpenLanguages()
    if (response.status === 200) {
        dispatch(setOpenLanguages(response.data.data))
        return { status: true }
    } else {
        return { status: false }
    }
}

export const getLanguage = async (id: string, dispatch: any) => {
    const response: any = await Language.getLanguage(id)
    if (response.status === 200) {
        dispatch(setLanguage(response.data.data))
        return { status: true }
    } else {
        return { status: false }
    }
}

export const deleteLanguage = async (id: string, toast: any, dispatch: any) => {
    const response: any = await Language.deleteLanguage(id)
    if (response.status === 200) {
        dispatch(setLanguages(response.data.data))
        toast({
            description: `La langue a été supprimée avec succès`,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: true }
    } else if (response.status !== 500) {
        toast({
            description: `${response?.message?.message}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    } else {
        toast({
            description: `quelque chose s'est mal passé !`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    }
}

export const translateLanguageQuestions = async (id: number, toast: any) => {
    toast({
        description: `les questions sont en cours de traduction. Ce processus peut prendre un certain temps`,
        status: 'info',
        duration: 5000,
        isClosable: true,
        position: 'top'
    })
    const response: any = await Language.translateLanguageQuestions(id)
    if (response.status === 200) {
        toast({
            description: `les questions ont été traduites avec succès`,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: true }
    } else if (response.status !== 500) {
        toast({
            description: `${response?.message?.message}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    } else {
        toast({
            description: `quelque chose s'est mal passé !`,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top'
        })
        return { status: false }
    }
}

